<h1>{{ "history" | i18n }}</h1>
<div
  *ngFor="let userLog of preparedUserLogs$ | async"
  class="user-log-entry">
  <div class="user-log-icon">
    <mat-icon
      [svgIcon]="userLog.icon"
      class="size-20"
      [class.text-icon-grey]="userLog.colorType === 'neutral'"
      [class.text-icon-success]="userLog.colorType === 'success'"
      [class.text-icon-warning]="userLog.colorType === 'warning'"
      [class.text-icon-error]="userLog.colorType === 'danger'"></mat-icon>
  </div>
  <div class="user-log-data">
    <div class="user-log-entry-info">
      {{ userLog.timestamp | date: "dd.MM.yyyy HH:mm" }}
      <ng-container *ngIf="userLog.user">
        - {{ userLog.user.firstName }} {{ userLog.user.lastName }}
      </ng-container>
    </div>
    <div class="user-log-message">
      <ng-container
        *ngIf="
          userLog.type === EmploymentUserLogTypeEnum.SELF_SIGN_IN_AVAILABLE
        ">
        {{ "userReportedForSelfSignIn" | i18n }}
      </ng-container>
      <ng-container *ngIf="userLog.type === EmploymentUserLogTypeEnum.INVITED">
        {{ "userWasInvited" | i18n }}
      </ng-container>
      <ng-container
        *ngIf="userLog.type === EmploymentUserLogTypeEnum.INVITEE_AVAILABLE">
        {{ "userHasAccepted" | i18n }}
      </ng-container>
      <ng-container
        *ngIf="userLog.type === EmploymentUserLogTypeEnum.INVITEE_UNAVAILABLE">
        {{ "userHasDeclined" | i18n }}
      </ng-container>
      <ng-container
        *ngIf="userLog.type === EmploymentUserLogTypeEnum.SET_TO_AVAILABLE">
        {{ "userSetToAvailable" | i18n }}
      </ng-container>
      <ng-container
        *ngIf="userLog.type === EmploymentUserLogTypeEnum.SET_TO_UNAVAILABLE">
        {{ "userSetToUnavailable" | i18n }}
      </ng-container>
      <ng-container *ngIf="userLog.type === EmploymentUserLogTypeEnum.DECLINED">
        {{ "userWasDeclined" | i18n }}
        <div
          *ngIf="data.invitee?.declineReason && declineReasonEnum?.[data.invitee!.declineReason!]"
          data-cy="invitee-decline-reason">
          <span>{{ ("reason" | i18n) || "Grund" }}:</span>
          <span *ngIf="data.invitee?.declineReason === declineReasonEnum.OTHER">
            {{ data.invitee?.declineReasonDescription }}
          </span>
          <span *ngIf="data.invitee?.declineReason !== declineReasonEnum.OTHER">
            {{ "declineReasonEnum." + data.invitee!.declineReason! | i18n }}
          </span>
        </div>
      </ng-container>
      <ng-container *ngIf="userLog.type === EmploymentUserLogTypeEnum.BOOKED">
        {{ "userWasAccepted" | i18n }}
      </ng-container>
      <ng-container
        *ngIf="userLog.type === EmploymentUserLogTypeEnum.POSSIBLE_CANDIDATE">
        {{ "userWasSubmittedAsPossibleCandidate" | i18n }}
      </ng-container>
      <ng-container
        *ngIf="userLog.type === EmploymentUserLogTypeEnum.CANCELLED">
        {{ "userWasCancelled" | i18n }}
        <div
          *ngIf="data.invitee?.cancelReason"
          data-cy="invitee-cancel-reason">
          <span>{{ ("reason" | i18n) || "Grund" }}:</span>
          <span *ngIf="data.invitee?.cancelReason?.enableDescription">
            {{ data.invitee?.cancelReasonDescription }}
          </span>
          <span *ngIf="!data.invitee?.cancelReason?.enableDescription">
            {{ data.invitee?.cancelReason?.displayName }}
          </span>
        </div>
      </ng-container>
    </div>
  </div>
</div>
